export const environment = {
  production: true,
  BASE_URL: "https://sistemas.globalsys.com.br:7023/api"
};
